module.exports = __webpack_public_path__ + "assets/font/AlibabaPuHuiTi-3-55-Regular-eb0d590a.ttf";